import React, { Component } from 'react';

import {
	Button,
	Row,
	Col
} from 'react-bootstrap';

export default class FooterButtons extends Component {

	render() {
		return(
			<Row>
				<Col xs={6}>
					<Button block onClick={this.props.cancel}>
						{this.props.cancelButton}
					</Button>
				</Col>
				<Col xs={6}>
					<Button block bsStyle="primary" onClick={this.props.save} disabled={this.props.isDisabled}>
						{this.props.saveButton}
					</Button>
				</Col>
			</Row>
		);
	}
}
